import React from "react";
import { ToastContainer } from "react-toastify";
import ReArrangeProduct from "../../components/ProductManager/Product/ReArrangeProduct";

export const ReArrangeProductPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ReArrangeProduct />
        </div>
      </div>
    </div>
  );
};
